import initialstate from '../initialstate';
import {GET_RELATED_WCGWS} from '../../actions/actiontypes';
import dataFieldSeparator from '../../util/uiconstants';
import {labels} from '../../util/utils';

function formatData(data) {
	var result = [];

	data.forEach((risk) => {
		risk.assertions.forEach((assertion) => {
			if (assertion.wcgWs.length > 0) {
				assertion.wcgWs.forEach((wcgw) => {
					wcgw.scoTs.forEach((scot) => {
						result.push({
							engagementId: risk.engagementId,
							risk: `${risk.id}${dataFieldSeparator}${risk.riskName}`,
							riskType: risk.riskType,
							assertion: `${assertion.id}${dataFieldSeparator}${assertion.assertionName}${dataFieldSeparator}${assertion.assertionAbbreviation}${dataFieldSeparator}${assertion.accountName}${dataFieldSeparator}${assertion.craValue}${dataFieldSeparator}${assertion.inherentRiskTypeId}${dataFieldSeparator}${assertion.controlRiskTypeId}${dataFieldSeparator}${assertion.hasRiskAssociated}`,
							wcgwId: wcgw.id,
							wcgwName: wcgw.wcgwName,
							scot: `${scot.id}${dataFieldSeparator}${scot.scotName}`
						});
					});
				});
			} else {
				result.push({
					engagementId: risk.engagementId,
					risk: `${risk.id}${dataFieldSeparator}${risk.riskName}`,
					riskType: risk.riskType,
					assertion: `${assertion.id}${dataFieldSeparator}${assertion.assertionName}${dataFieldSeparator}${assertion.assertionAbbreviation}${dataFieldSeparator}${assertion.accountName}${dataFieldSeparator}${assertion.craValue}${dataFieldSeparator}${assertion.inherentRiskTypeId}${dataFieldSeparator}${assertion.controlRiskTypeId}${dataFieldSeparator}${assertion.hasRiskAssociated}`,
					wcgwId: 0,
					wcgwName: labels.noWcgwsIdentified
				});
			}
		});
	});

	return result;
}

export default function relatedWCGWsReducer(state = initialstate.relatedWCGWs, action) {
	switch (action.type) {
		case GET_RELATED_WCGWS:
			if (action.response) {
				if (action.response.data) {
					action.response.data = formatData(action.response.data);
				} else {
					return {
						data: []
					};
				}
			}
			return action.response || state;

		default:
			return state;
	}
}
